<div [ngClass]="{isMobileDevice:pagination.isMobile}" >
  <div>
  <div #paginationcontainer class=" pagination-box" *ngIf="pagination.paginationStatus">
    <ul class="paginationNumbers" >
      <li *ngIf="!pagination.isMobile" class="pagination" (click)="selectPage(pagination.currentPage - 1, $event)" [class.disabled]="pagination.currentPage == 1">
        <a href="" title="Go to previous page" aria-label="prevPage"><i class="icon-left" aria-hidden="true"></i></a>
      </li>
      <li class="pagination" [ngClass]="{highlightCurrentPage:page == pagination.currentPage}" *ngFor="let page of pagination.initialPages">
        <a href="" (click)="selectPage(page, $event)" [attr.aria-label]="page == pagination.currentPage ? 'page '+ page +' link is currently active' : 'page ' + page">{{page}}</a>
      </li>
      <li *ngIf="pagination.pageSeqType != 'start' && pagination.pageSeqType != 'all'" class="pagination">
        <a>...</a>
      </li>
      <li class="pagination" [ngClass]="{highlightCurrentPage:page == pagination.currentPage}" *ngFor="let page of pagination.middlePages">
        <a href="" [attr.aria-label]="page == pagination.currentPage ? 'page '+ page +' link is currently active' : 'page ' + page" (click)="selectPage(page, $event)">{{page}}</a>
      </li>
      <li *ngIf="pagination.pageSeqType != 'end' && pagination.pageSeqType != 'all'" class="pagination">
        <a>...</a>
      </li>
      <li class="pagination" [ngClass]="{highlightCurrentPage:page == pagination.currentPage}" *ngFor="let page of pagination.finalPages">
        <a href="" [attr.aria-label]="page == pagination.currentPage ? 'page '+ page +' link is currently active' : 'page ' + page" (click)="selectPage(page, $event)">{{page}}</a>
      </li>
      <li *ngIf="!pagination.isMobile" class="pagination" (click)="selectPage(pagination.currentPage + 1, $event)" [class.disabled]="pagination.currentPage == pagination.totalPages">
        <a href="" title="Go to next page" aria-label="nextPage"><i class="icon-right" aria-hidden="true"></i></a>
      </li>
    </ul>
  </div>
  <div class="hide-sm  go-label" *ngIf="pagination.paginationStatus && !hideGoToPage">
    <label for="goto">Go to page:</label>
    <input type="text" id="goto" (keyup)="isValidPage(pageNo.value)" name="gotopage" #pageNo (keydown.enter)="selectPage(pageNo.value, $event)" aria-label="Enter page number." placeholder="" class="form-control" />
    <a href="javascript:void(0)" *ngIf="!disableButton"  (click)="selectPage(pageNo.value, $event)" class="btn-circle"  aria-label="Go"><i class="icon-right" aria-hidden="true"></i></a>
    <span *ngIf="disableButton"  [ngClass]="{disableLink:disableButton}" class="btn-circle"  aria-label="Go"><i class="icon-right" aria-hidden="true"></i></span>
  </div>
  <div class="clearfix"></div>
</div>
</div>
